import { Routes, Route } from 'react-router-dom';
import { HomePage } from './components/pages/Home';
import { AboutPage } from './components/pages/About';
import { BuyPage } from './components/pages/Buy';
import { PresalePage } from './components/pages/Presale';
import { TokenomicsPage } from './components/pages/Tokenomics';
import { RoadmapPage } from './components/pages/Roadmap';
import { RedemptionPage } from './components/pages/Redemption';
import { GovernancePage } from './components/pages/Governance';
import { EcosystemPage } from './components/pages/Ecosystem';
import { UtilitiesPage } from './components/pages/Utilities';
import { ResourcesPage } from './components/pages/Resources';
import { FaqPage } from './components/pages/Faq';
import { TeamPage } from './components/pages/Team';
import { CommunityPage } from './components/pages/Community';

import { SecurityPage } from './components/pages/Security';
import { XenditPaymentPage } from './components/pages/XenditPayment';
import { PaymentInstructionsPage } from './components/pages/PaymentInstructions';
import { WhitepaperPage } from './components/pages/Whitepaper';

import { Compliance } from './components/pages/Compliance';
import { RiskDisclosure } from './components/pages/RiskDisclosure';
import { RedemptionPolicy } from './components/pages/RedemptionPolicy';
import { Attestation } from './components/pages/Attestation';

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/buy" element={<BuyPage />} />
      <Route path="/presale" element={<PresalePage />} />
      <Route path="/tokenomics" element={<TokenomicsPage />} />
      <Route path="/roadmap" element={<RoadmapPage />} />
      <Route path="/whitepaper" element={<WhitepaperPage />} />
      <Route path="/redemption" element={<RedemptionPage />} />
      <Route path="/governance" element={<GovernancePage />} />
      <Route path="/ecosystem" element={<EcosystemPage />} />
      <Route path="/utilities" element={<UtilitiesPage />} />
      <Route path="/resources" element={<ResourcesPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/community" element={<CommunityPage />} />
      {/* <Route path="/compliance" element={<CompliancePage />} /> */}
      <Route path="/security" element={<SecurityPage />} />

      {/* Legal Pages */}
      <Route path="/compliance" element={<Compliance />} />
      <Route path="/risk-disclosure" element={<RiskDisclosure />} />
      <Route path="/redemption-policy" element={<RedemptionPolicy />} />
      <Route path="/attestation" element={<Attestation />} />

      {/* Payment Routes */}
      <Route path="/payment" element={<XenditPaymentPage />} />
      <Route path="/payment/instructions" element={<PaymentInstructionsPage />} />

      {/* Fallback route */}
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
};